import React from 'react';
import { useTranslation } from 'react-i18next';

// #298 : bascule FR/EN, même pattern que le simulateur (#294).
// i18next-browser-languagedetector persiste déjà le choix dans localStorage
// (clé i18nextLng) via i18n.changeLanguage, donc rien de plus à faire ici
// pour la mémorisation.
const LanguageSwitcher = ({ className = '' }) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'fr';

  const switchTo = (lang) => {
    if (lang !== currentLang) {
      i18n.changeLanguage(lang);
    }
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-orange-200 bg-white text-sm overflow-hidden shadow-sm ${className}`}
      role="group"
      aria-label={t('languageSwitcher.label')}
    >
      <button
        type="button"
        onClick={() => switchTo('fr')}
        className={`px-2.5 py-1.5 font-medium transition-colors ${currentLang === 'fr' ? 'bg-gradient-to-r from-orange-500 to-yellow-500 text-white' : 'text-gray-600 hover:bg-orange-50'}`}
        aria-pressed={currentLang === 'fr'}
      >
        FR
      </button>
      <button
        type="button"
        onClick={() => switchTo('en')}
        className={`px-2.5 py-1.5 font-medium transition-colors ${currentLang === 'en' ? 'bg-gradient-to-r from-orange-500 to-yellow-500 text-white' : 'text-gray-600 hover:bg-orange-50'}`}
        aria-pressed={currentLang === 'en'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
